export default __webpack_public_path__ + "static/media/herbal.ef87b684.svg";